import { Component, input } from '@angular/core';
import { PageWithDrawerComponent } from '@myarvato/shared/page-with-drawer';
import { DetailViewDto } from '@myarvato/modules/transport/models';
import { DetailsSidebarComponent } from '../details-sidebar/details-sidebar.component';
import { DetailsMetaComponent } from '../details-meta/details-meta.component';
import { DetailsMilestonesComponent } from '../details-milestones/details-milestones.component';
import { DetailsEventHistoryComponent } from '../details-event-history/details-event-history.component';
import { DetailsBulkComponent } from '../details-bulk/details-bulk.component';
import { DetailsSenderRecipientComponent } from '../details-sender-recipient/details-sender-recipient.component';
import { DetailsContentsComponent } from '../details-contents/details-contents.component';
import { DetailsDocumentsComponent } from '../details-documents/details-documents.component';

@Component({
  selector: 'transport-details',
  imports: [
    PageWithDrawerComponent,
    DetailsSidebarComponent,
    DetailsMetaComponent,
    DetailsMilestonesComponent,
    DetailsEventHistoryComponent,
    DetailsBulkComponent,
    DetailsSenderRecipientComponent,
    DetailsContentsComponent,
    DetailsDocumentsComponent,
  ],
  templateUrl: './details.component.html',
  styleUrl: './details.component.scss',
})
export class DetailsComponent {
  public readonly details = input.required<DetailViewDto>();
}
